export default "__VITE_ASSET__Bc_IlCgp__"